import styled from "styled-components";

export const ActionFieldContainer = styled.div`
    align-items: center;
    display: flex;
    gap: 24px;
    width: 100%;
`;